"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordPage = ResetPasswordPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var auth_layout_1 = require("../../components/auth/auth-layout");
var reset_password_form_1 = require("../../components/auth/reset-password-form");
/**
 * Deliberately unguarded: a stale or signed-in session must not redirect away from this URL,
 * because that would discard the one-time oobCode the reset link carries.
 */
function ResetPasswordPage() {
    return ((0, jsx_runtime_1.jsx)(auth_layout_1.AuthLayout, { title: "Reset Password.", subtitle: "Choose a new password for your account.", children: (0, jsx_runtime_1.jsx)(reset_password_form_1.ResetPasswordForm, {}) }));
}
